import React from "react";
import "../../styles/Css/Home.css";

const HomeSection = () => {
    return (
        <div className="home">
            <section className="hero">
                <div className="hero__bg">
                    <div className="hero__gradient-orb hero__gradient-orb--1"></div>
                    <div className="hero__gradient-orb hero__gradient-orb--2"></div>
                </div>
                <div className="hero__container">
                    <div className="hero__content">
                        <span className="hero__badge">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                            </svg>
                            AI-Powered Automation
                        </span>
                        <h1 className="hero__title">
                            Close More<br />Deals.<br />
                            <span className="gradient-text">Let AI Handle<br />the Paperwork.</span>
                        </h1>
                        <p className="hero__description">
                            Deal to Close AI automates up to 70% of your real estate transaction workflow — from contract analysis and task lists to emails, and insights — all for just <strong>$10 per user per month</strong>.
                        </p>
                        <div className="hero__cta">
                            <a href="#signup" className="btn btn-primary btn-lg">
                                Start Free in 2 Minutes
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <line x1="5" y1="12" x2="19" y2="12" />
                                    <polyline points="12 5 19 12 12 19" />
                                </svg>
                            </a>
                            <span className="hero__cta-note">No credit card required • 14-day free trial</span>
                        </div>
                        <div className="hero__tags">
                            <span className="hero__tag">AI + Compliance</span>
                            <span className="hero__tag">CRM Integration</span>
                            <span className="hero__tag">MLS Ready</span>
                            <span className="hero__tag">assasasas</span>
                        </div>
                    </div>
                    <div className="hero__visual">
                        <div className="hero__laptop">
                            <div className="hero__laptop-screen">
                                <div className="hero__dashboard">
                                    <div className="hero__dashboard-header">
                                        <span className="hero__dashboard-dot"></span>
                                        <span className="hero__dashboard-dot"></span>
                                        <span className="hero__dashboard-dot"></span>
                                    </div>
                                    <div className="hero__dashboard-content">
                                        <div className="hero__dashboard-sidebar">
                                            <div className="hero__dashboard-menu-item"></div>
                                            <div className="hero__dashboard-menu-item"></div>
                                            <div className="hero__dashboard-menu-item"></div>
                                        </div>
                                        <div className="hero__dashboard-main">
                                            <div className="hero__dashboard-card"></div>
                                            <div className="hero__dashboard-card"></div>
                                            <div className="hero__dashboard-card hero__dashboard-card--wide"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
};

export default HomeSection;